export { ColorsSidebar } from './ColorsSidebar';
